import { createFileRoute } from '@tanstack/react-router';
import { assertPublicToolsEnabled } from '@/lib/public-tools-feature';
import { SeoLayout } from '@/components/astro/new-design-25/SEO/seo-layout';
import { seo } from '@/seo/seo';

const heroTitle = 'Text to Speech for ADHD';
const heroDescription =
  'Text to speech tools tailored for ADHD learners. Improve focus and attention while reading with audio support that helps maintain concentration and engagement.';

const featureTitle = heroTitle;
const featureSubtitle = 'Focus-enhancing audio';
const featureDescription = heroDescription;
const featureBadge = 'Focus Support';
const featureVariant = 'default';
const featureCtaText = 'Improve Focus';

const featureFeatures = [
  {
    title: 'Enhanced Attention',
    description:
      'Audio narration helps maintain focus on text content and reduces mind-wandering during reading.',
  },
  {
    title: 'Reduced Overwhelm',
    description:
      'Break down large texts into manageable audio segments to prevent information overload.',
  },
  {
    title: 'Active Engagement',
    description:
      'Keep your mind engaged with multi-sensory input that supports ADHD learning preferences.',
  },
];

export const Route = createFileRoute(
  '/_marketing/_seo/text-to-speech-for-adhd',
)({
  beforeLoad: assertPublicToolsEnabled,
  head: () => ({
    meta: [
      ...seo({
        title:
          'Text to Speech for ADHD - Focus-Enhancing Reading Tools | Listening',
        description:
          'Text to speech designed for ADHD learners. Audio support helps maintain focus and attention while reading. Reduce overwhelm and improve engagement.',
      }),
    ],
  }),
  component: () => (
    <SeoLayout
      featureBadge={featureBadge}
      featureCtaText={featureCtaText}
      featureDescription={featureDescription}
      featureFeatures={featureFeatures}
      featureSubtitle={featureSubtitle}
      featureTitle={featureTitle}
      featureVariant={featureVariant}
      pageDescription={heroDescription}
      pageTitle={heroTitle}
    />
  ),
});
